<script>
import Vue from "vue";
import NextLevelWithoutDSLeft from "./NextLevelWithoutDSLeft.vue";
import CheckoutForm from "../CheckoutForm.vue";
import Footer from "../../Footer.vue";
import Testimonial from "../Testimonial.vue";

export default {
  name: "NextLevelWithoutDSCheckout",
  page: {
    title: "Next Level Power Drops Checkout",
    meta: [{ name: "description", content: "Joing the Next Level Power Drops Program" }],
  },
  showCountDown: false,
  props: ["combos", "variant"],
  components: {
    NextLevelWithoutDSLeft,
    CheckoutForm,
    Footer,
    Testimonial,
  },
  data () {
    return {
      expirationDate: new Date("30 October 2020 23:59:59 PST"),
      changeBus: new Vue(),
      guaranteeImg: "redlock-ssl-30days.jpg",
      showCountDown: false,
      testimonials: {
        debrah: {
          photo: "powerdrops/testimonial-debrah-nadler.png",
          name: "Debrah Nadler",
          title: "Certi",
          quote:
            "You made chemistry understandable for someone like me who didn’t get it. I took chemistry in college and hated it. But I realized how important it was for aromatherapy. Melani, you made it so I could understand the parts I needed to know. I walked into your class feeling lost, and left finally getting it. If I can understand it, anybody can with Melani’s way of teaching."
        },
        sylvia: {
          photo: "powerdrops/testimonial-sylvia.png",
          name: "Sylvia Provenski",
          title: "Nurse & Essential Oil Advocate",
          quote:
            "I’ve taken hundreds of courses over the years, but I’ve never seen essential oil education presented the way you do. The content is so unique, so clearly thought through. As a former nurse, I’ve always wanted to understand the deeper ‘why’ behind what I’m doing with oils especially for safety. And that’s exactly what your program offers."
        },
        branko: {
          photo: "powerdrops/testimonial-branko.png",
          name: "Branko Čičić",
          title: "Aromatherapy Consultant",
          quote:
            "Melani makes even the most complex aspects of aromatherapy feel simple and applicable. Her knowledge is deep, her mind brilliant, and her teaching style beautifully intuitive."
        },
        marika: {
          photo: "powerdrops/testimonial-marika-fleri.png",
          name: "Marika Fleri",
          title: "Clinical Aromatherapist, Educator, Founder of AromaHub",
          quote:
            "Melani’s approach to aromatherapy (especially chemistry) is innovative, fresh, deep and fun all rolled into one. She’s our global Aroma Genius."
        },
        tammy: {
          photo: "powerdrops/testimonial-tammy.png",
          name: "Tammy Kell",
          title: "Aromatherapist",
          quote:
            "I LOVED Lesson One! I took a full page of notes. Melani re-ignited my joy for learning. The chemistry insights and support from her team have been phenomenal."
        },
        nina: {
          photo: "powerdrops/testimonial-nina-glavac.png",
          name: "Prof. Dr. Nina Kočevar Glavač",
          title: "Professor & Researcher, Faculty of Pharmacy Ljubljana",
          quote:
            "Melani’s EO expertise is current, her teaching clear, and her presence warm and respectful. She brings academic rigor and heartfelt connection — a rare and valuable blend."
        },
        zeljko: {
          photo: "powerdrops/testimonial-zeljko.png",
          name: "MSc Željko Radmanović",
          title: "Master of Osteopathy, Educator & Aromatherapist",
          quote:
            "Melani’s dedication and excellence have shaped national standards and enriched my programs for nearly a decade. She’s a true leader in the field."
        },
        rhiannon: {
          photo: "powerdrops/testimonial-rhiannon.png",
          name: "Rhiannon Lewis",
          title: "Clinical Aromatherapist, Educator, IJCA Editor, and founder of the ICAN & Botanica conference series",
          quote:
            "You’re such a remarkable individual and I deeply appreciate the perspective you bring to aromatherapy. What you’ve created with Dropsmart reflects that beautifully. It’s not just a tool for blending, it’s layered, multifaceted, rooted in research, and clearly shaped by someone who understands essential oils from the inside out."
        },        
      },
    };
  },
  computed: {
    expirationDateComputed() {

      // if the parameters are not set, doesn't show the CountDown object
      if ( (!this.$route.query.d || this.$route.query.d === 'undefined') ||
           (!this.$route.query.dl || this.$route.query.dl === 'undefined') ) {
        return null;
      }

      // Check if 'd' query parameter exists and is a valid Unix timestamp
      const timestampParam = this.$route.query.d;
      const daysToAdd = parseInt(this.$route.query.dl) || 7;

      if (timestampParam) {
        try {
          // Convert the timestamp to milliseconds by multiplying by 1000
          const date = new Date(parseInt(timestampParam) * 1000);

          // Validate the date object
          if (isNaN(date.getTime())) {
            throw new Error('Invalid date');
          }

          // Use UTC methods to add days
          date.setUTCDate(date.getUTCDate() + daysToAdd);

          // Return the new timestamp in milliseconds
          const newTimestamp = date.getTime();
          console.log("New Timestamp: " + newTimestamp);

          return newTimestamp;
        } catch (e) {
          console.error('Error parsing timestamp:', e);
        }
      }

      // If no valid 'd' query parameter or error in parsing, return current time + 7 days in timestamp
      console.error('Invalid or no timestamp parameter provided in the URL, using default.');
      const defaultDate = new Date();
      defaultDate.setUTCDate(defaultDate.getUTCDate() + 7);
      return defaultDate.getTime();
    },
    paymentPlanComputed() {
      // ?pp=<number>  -- enables a payment plan with that many installments.
      // Absent / non-numeric / <= 0 means "no payment plan", which is the
      // default for most page visits and should NOT be logged as an error.
      const pp = this.$route.query.pp;
      if (!pp || pp === 'undefined') {
        return 0;
      }
      const paymentPlan = Number(pp);
      return (!isNaN(paymentPlan) && paymentPlan > 0) ? paymentPlan : 0;
    },
    installmentOrderComputed() {
      // ?io=asc|desc -- controls how installment options are ordered. Absent
      // means use the default ('asc'); not an error worth logging.
      const io = this.$route.query.io;
      return (io === 'asc' || io === 'desc') ? io : 'asc';
    },
    productComboIdComputed() {
      try {
        const pid = this.$route.query.pid;
        
        // If pid parameter exists and is valid, use it
        if (pid && pid !== 'undefined') {
          const productComboId = Number(pid);
          if (!isNaN(productComboId) && productComboId > 0) {
            return [productComboId];
          }
        }
        
        // Default to combos prop from router (29 for NextLevel PowerDrops)
        return this.combos || [30];
      } catch (error) {
        console.error('Error in productComboIdComputed:', error.message);
        return this.combos || [30];
      }
    },
  },
  methods: {
    addHours(hours) {
      const today = new Date();
      today.setHours(today.getHours() + hours);
      return today;
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    },    
  },
}

</script>

<template>
  <b-container style="background-color: white; padding: 0 3rem">        
    <b-row class="checkout-content">
      <b-col sm="12" lg="6" class="content" style="text-align: left; color: #293847">
        <NextLevelWithoutDSLeft />
      </b-col>
      <b-col sm="12" lg="6" class="checkout">
        <CheckoutForm :loadCombos="productComboIdComputed" 
                      :guaranteeImg="guaranteeImg" 
                      :changeBus="this"
                      :paymentPlan="paymentPlanComputed"
                      :installmentOrder="installmentOrderComputed"
        />
      </b-col>
    </b-row>
    <div class="testimonials">
      <b-row>
        <b-col><Testimonial :testimonial="testimonials.debrah" /></b-col>
        <b-col><Testimonial :testimonial="testimonials.sylvia" /></b-col>
      </b-row>
      <b-row>
        <b-col><Testimonial :testimonial="testimonials.branko" /></b-col>
        <b-col><Testimonial :testimonial="testimonials.marika" /></b-col>
      </b-row>
      <b-row>
        <b-col><Testimonial :testimonial="testimonials.tammy" /></b-col>
        <b-col><Testimonial :testimonial="testimonials.nina" /></b-col>
      </b-row>
      <b-row>
        <b-col><Testimonial :testimonial="testimonials.rhiannon" /></b-col>
        <b-col><Testimonial :testimonial="testimonials.zeljko" /></b-col>
      </b-row>
    </div>
    <br />
    <b-row>
      <b-col sm="12" lg="12">
        <b-card no-body>
          <b-row>
            <b-col md="4">
              <b-card class="text-center" border-variant="light" style="padding-top: 1.75rem">
                <b-card-img
                  img-top
                  :src="require('@/assets/powerdrops/thumb-melani.png')"
                  style="height: 90px; width: 90px; display: block; margin: auto; border-radius: 50%;"
                />
                <b-card-title title="Melani Kovač"></b-card-title>
                <b-card-body class="text-center"
                  >Dropsmart's (formerly Dropsmart) founder, Aromatherapist and Lecturer at Higher school of applied sciences</b-card-body
                >
              </b-card>
            </b-col>
            <b-col md="8">
              <b-card-body style="line-height: 1.5em; font-size: 1.2em; padding: 2rem">
                <h5 style="font-weight: bold">Your teacher</h5>
                <p>
                  Melani is an internationally recognized aromatherapy educator, innovator, and the creator of EO Architecture — a professional framework that has redefined how essential oils are studied and practiced. With nearly two decades of experience, she has lectured at universities, spoken at major international conferences, and served on the national committee that wrote and established aromatherapy as a recognized career in Slovenia. As the founder of Dropsmart and the Melani Method, she has guided thousands of aromatherapists, educators, and wellness professionals to move beyond memorizing facts — into practicing with clarity, certainty, and authentic creativity.
                  <br/><br/>
What sets Melani apart is her gift for making complex chemistry practical and joyful. She translates research and science into simple systems that professionals can actually use — in consults, classrooms, and product creation. Her mission is clear: to equip aromatherapists with the frameworks and tools that make their knowledge visible, respected, and future-proof in a world overflowing with information.
                </p>
              </b-card-body>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12" class="text-center" style="margin: 2rem 0 2rem 0">
        <h2 style="font-weight: 600; text-transform: uppercase">NEXT LEVEL POWER DROPS Program Modules</h2>
      </b-col>
      <b-col md="12" style="margin: 2rem 0 2rem 0">
        <ul style="padding-left: 1em; font-size: 1.5em;">
          <li>Module #1: Enhancing your essential oil chemistry awareness.</li>
          <li>Module #2: Introduction to Sinergy.</li>
          <li>Module #3: The Next Level of fundamentals.</li>
          <li>Module #4: Next steps &amp; sinergy.</li>
          <li>Module #5: Connecting the dots.</li>
          <li>Module #6: EXCLUSIVE BONUS with Modern cosmetics.</li>
          <li>Module #7: Chemistry &amp; aroma.</li>
          <li>Module #8: The power of sophisticated formulating.</li>
          <li>Module #9: Closing lessons - The full circle.</li>
          <li>Module #10: BONUS material &amp; clarifying your inquiries.</li>
        </ul>
      </b-col>

    </b-row>
    <b-row>
      <b-col md="12" class="text-center" style="margin: 2rem 0 2rem 0">
        <h2 style="font-weight: 600; text-transform: uppercase">MINI-MODULES AND MODERN COSMETICS BONUS</h2>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="6">
        <ul id="bonus-left">
          <li>15 Power Blending Mini Modules including:</li>
          <li style="list-style-type: none">
            <ul style="padding-left: 1em;">
              <li>Power blending for awesome skin results</li>
              <li>Power blending secrets for massage therapists</li>
              <li>Power blending tips &amp; tricks for moms &amp; kids</li>
              <li>Power blending for spotless cleaning with essential oils</li>
              <li>Power blending tips and tricks health professionals</li>
              <li>Power blending for anxiety and stress support</li>
              <li>Power blending for activating energy and focus</li>
              <li>Power blending for wellbeing</li>
              <li>Power blending to ease pain</li>
              <li>Power blending to strengthen and assist the immune system</li>
              <li>Power blending to support the respiratory system</li>
              <li>Power blending and creating the harmonious aroma</li>
              <li>Power blending simple steps to better sleep</li>
              <li>Power blending for yoga studios and meditation</li>
              <li>Power blending surprise module</li>
            </ul>
          </li>
          <li>5 Power Drops Mini Modules for aromatherapy educators</li>
        </ul>
      </b-col>
      <b-col md="6">
        <ul id="bonus-right">
          <li>2 Modern CosmEthics exclusive surprises</li>
          <li style="list-style-type: none">
            <ul>
              <li>
                <p>
                  Exclusive Modern CosmEthics training with the mastermind and chief editor of the globally acclaimed Modern Cosmetics book
                </p>
                <strong>Prof. Dr. Nina Kočevar Glavač</strong>
                <img src="@/assets/powerdrops/modern-cosmetics-1.jpg" />
                <br />
                <h4><strong>Module 1</strong></h4>
                <span>Natural Cosmetics - What is there to know?</span>
                <h4><strong>Module 2</strong></h4>
                <span>Vegetable butters and oils: Scientific evidence for cosmetic and therapeutic use</span>
              </li>
              <li>
                <p>Exclusive Modern CosmEthics practical workshop with <strong>Katja Schoss, MSc, Bachelor of Cosmetic Sciences</strong></p>
                <img src="@/assets/powerdrops/modern-cosmetics-2.jpg" />
              </li>
            </ul>
          </li>
        </ul>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div style="margin-top: 3rem; text-align: center">
          <button
            class="button-checkout"
            style="max-width: 22em"
            v-scroll-to="'#time-counter-container'"
            @click="scrollToTop"
          >
            <span id="button-text">Click here to enroll now</span>
          </button>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12" class="text-center">
        <div style="margin-top: 2rem">
          <h2 style="font-weight: 600; font-size: 1.5em; margin-top: 2em">30-day money-back guarantee</h2>
        </div>
      </b-col>
    </b-row>
    <Footer />
  </b-container>
</template>

<style lang="scss">
$vs-state-active-bg: #f7f7f7;
$vs-state-active-color: #444;

@font-face {
  font-family: OpenSans;
  src: url(../../../assets/fonts/OpenSans-Light.ttf);
  font-weight: 200;
}

@font-face {
  font-family: OpenSans;
  src: url(../../../assets/fonts/OpenSans-Regular.ttf);
  font-weight: 400;
}

@font-face {
  font-family: OpenSans;
  src: url(../../../assets/fonts/OpenSans-Bold.ttf);
  font-weight: 600;
}

// Global Settings
$font-family: "OpenSans";
$font-bold: 700;

// Form Settings
$border-input: 1px solid #f7f7f7;
$bg-input: #f7f7f7;
$color-input: #000000;
$font-size-input: 18px;
$color: #000000;
$line-height-input: 23px;
$padding-input: 15px 18px 15px 55px;
$link-color: #68a432;

// Icon Settings
$icon-color: #999999;

* {
  font-family: $font-family;
}

.alert-error {
  color: #ff0000;
  font-size: 16px;
  margin: 0 !important;
  padding: 0 !important;
  text-align: center;
}

.header-checkout {
  text-align: center;
  h2 {
    font-size: 36px !important;
    font-weight: 600;
    color: black ;
  }
}
@media screen and (min-width: 481px) {
  /*.header-checkout:before {
    content: url(../../../assets/images/img-icons.png);
    position: absolute;
    right: 0;
    pointer-events: none;
  }*/
}
.checkout-content {
  padding-bottom: 0;
  margin-bottom: 0;
  display: flex;
  align-items: stretch;
}

.logo-row {
  margin: 65px 0 0;
  .logoCheckout {
    width: 100%;
    max-width: 228px !important;
    margin: 0 auto;
  }
}
.call-to-action {
  margin: 50px 0 10px;
  height: 80px;
  background-image: url(../../../assets/powerdrops/call-to-action-background.png);
  background-size: contain;
  background-repeat: no-repeat;
}
.call-to-action h2 {
  font-family: "OpenSans";
  font-size: 36px;
  color: #b8b8b8;
  text-transform: uppercase;
  line-height: 1.3;
}

#time-counter-container {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 0 40px 0;
}

.button-checkout {
  background: #ff0000;
  color: #ffffff;
  border: none;
  border-radius: 30px;
  width: 100%;
  font-size: 20px;
  text-transform: uppercase;
  padding: 15px;
  line-height: 25px;
}

.button-checkout:hover {
  background: #89c157 !important;
}

#time-counter-container div {
  width: 3em;
  font-size: 3rem;
  font-weight: 400;
}
#time-counter-container span {
  float: right;
}
#time-counter-container .value {
  height: 60px;
}
#time-counter-container .label {
  font-weight: normal;
  font-size: 0.9rem;
  width: auto;
  text-align: center;
  text-transform: uppercase;
  color: #555;
}

#bonus-left {
  font-size: 1.05rem;
  line-height: 2.75em;
}

ul#bonus-left > li {
  font-weight: bold;
  list-style: disc;
}
ul#bonus-left > li li {
  font-weight: normal;
  list-style: disc;
}

ul#bonus-right {
  line-height: 2.75em;
  width: 88%;
}

ul#bonus-right > li {
  font-weight: bold;
  list-style: disc;
}

ul#bonus-right > li li {
  font-weight: normal;
  line-height: 1em;
  margin-bottom: 2rem;
  list-style: disc;
}

ul#bonus-right h4 {
  font-size: 1.1rem;
  margin-bottom: 6px;
  margin-top: 16px;
}
#expired-offer-link {
  font-size: 1.5rem;
  color: red;
  font-weight: 900;
}

#expired-offer-link:hover {
  color: red;
  text-decoration: underline;
}
#expired-offer-link:visited {
  color: red;
  text-decoration: none;
}
</style>
